import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
// Classes
import Platform from "./Platform.js"; // Types
var _ipProvider = /*#__PURE__*/_classPrivateFieldLooseKey("ipProvider");
var _timeProvider = /*#__PURE__*/_classPrivateFieldLooseKey("timeProvider");
export default class RECLogContext {
  constructor(options) {
    this.offerID = void 0;
    this.platform = void 0;
    this.userID = void 0;
    Object.defineProperty(this, _ipProvider, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _timeProvider, {
      writable: true,
      value: void 0
    });
    const {
      ipProvider,
      offerID,
      timeProvider,
      userID
    } = options;
    _classPrivateFieldLooseBase(this, _ipProvider)[_ipProvider] = ipProvider;
    _classPrivateFieldLooseBase(this, _timeProvider)[_timeProvider] = timeProvider;
    this.offerID = offerID;
    this.platform = new Platform(options);
    this.userID = userID;
  }
  get clientIP() {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    return (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _ipProvider))[_ipProvider]) == null ? void 0 : _classPrivateFieldLoo.call(_classPrivateFieldLoo2);
  }
  get ts() {
    var _classPrivateFieldLoo3, _classPrivateFieldLoo4;
    return ((_classPrivateFieldLoo3 = (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _timeProvider))[_timeProvider]) == null ? void 0 : _classPrivateFieldLoo3.call(_classPrivateFieldLoo4)) || Math.round(Date.now() / 1000);
  }
}
//# sourceMappingURL=RECLogContext.js.map